import { Modal, Divider, Button } from "antd";
import { useEffect, useRef, useState } from "react";
import styles from "./winner.module.scss";
import styled from "styled-components";
import { complexDigitToman } from "../../../../tools/tools";
import { useTenders } from "../../../../tools/api";
import Loading from "../../../../components/loader/loading";
import Fireworks from "@fireworks-js/react";
const WinnerModal = ({ open, value = {}, callback }) => {
  const { paidBidTenderByCustomer } = useTenders();
  const [isOpen, setIsOpen] = useState();

  const [isLoading, setIsLoading] = useState(false);

  const ref = useRef(null);
  const [fireWorks, setFireWorks] = useState({
    opacity: 1,
    intensity: 60,
    explosion: 10,
    rocketsPoint: { min: 0, max: 100 },
  });

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const handleCancel = (state = false) => {
    setIsOpen(false);
    callback(state);
  };

  const MyModal = styled(Modal)`
    .ant-modal-content {
      padding: 0;
      border-radius: 0.6875rem;
      overflow: hidden;
    }
  `;
  const Holder_Button = styled.div`
    display: flex;
    .btn-normal {
      height: 3.125rem;
      margin-right: 1rem;
      border-radius: 2rem;
      min-width: 10rem;
    }
  `;

  const switchTagBag = (type = 0) => {
    switch (type) {
      case 0:
        return "gold";
      case 1:
        return "platinum";
      case 2:
        return "silver";
      case 3:
        return "bronze";
      case 4:
        return "aptel";
      default:
        return "";
    }
  };

  const handleSubmit = async () => {
    try {
      if (value?.walletAmount - (value?.userBid - value?.tenderDeposit) >= 0) {
        setIsLoading(true);
        const payLoad = {
          auctionid: value?.auctionProductId,
        };
        const paymentBid = await paidBidTenderByCustomer(payLoad);
        if (paymentBid) {
          callback(true);
        }
        setIsLoading(false);
      } else {
        setIsOpen(false);
        callback({ state: "pending", amount: value?.userBid - value?.tenderDeposit });
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };
  return (
    <>
      <MyModal onCancel={() => handleCancel(false)} width={"54.9375rem"} centered open={isOpen} closeIcon={<></>} footer={<></>}>
        <Fireworks
          ref={ref}
          options={fireWorks}
          style={{
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            position: "fixed",
            background: "transparent",
          }}
        />
        <div className={styles.holderWinner} style={{ backgroundImage: `url(${process.env.PUBLIC_URL + "/assets/images/winner.jpg"})` }}>
          <div className={styles.holdContent}>
            <div className={styles.icon_shaypoor}>
              <img src={process.env.PUBLIC_URL + "/assets/images/Sheipoor.png"} />
            </div>
            <div className={styles.title_winner}>
              {value?.firstname} عزیز،<span> شما برنده مزایده شده اید</span>
            </div>
            <div className={styles.box_winner}>
              <div className={styles.row_box}>
                <div className={styles.text_box}>
                  <ul>
                    <li>
                      <div className={styles.label}>قیمت پیشنهادی شما:</div>
                      <div className={styles.value}>
                        <span>{complexDigitToman(value?.userBid)} </span> تومان
                      </div>
                    </li>
                    <li>
                      <div className={styles.label}>ودیعه:</div>
                      <div className={styles.value}>
                        <span>{complexDigitToman(value?.tenderDeposit)}</span> تومان
                      </div>
                    </li>
                    <li>
                      <div className={styles.label}>مبلغ قابل پرداخت</div>
                      <div className={styles.value}>
                        <span>{complexDigitToman(value?.userBid - value?.tenderDeposit)} </span> تومان
                      </div>
                    </li>
                  </ul>
                </div>
                <div className={styles.img_box}>
                  <img src={process.env.PUBLIC_URL + "/assets/images/sim.png"} alt="" />
                  <div className={styles.msisdn}>{value?.auctionTitle}</div>
                  <div className={styles.package}>{value?.bundle?.bundleName}</div>
                  <div className={styles.tag} data-type={switchTagBag(value?.auctionProductTypeId)}>
                    طلایی
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.textPayment}>
              <p>
                ضمن تبریک به شما، لطفا حداکثر تا 24 ساعت آینده نسبت به پرداخت مبلغ مزایده اقدام فرمایید. پس از پرداخت، همکاران ما برای انجام هماهنگی
                ارسال سیمکارت با شما تماس خواهند گرفت.
              </p>
            </div>
            <div className={styles.holdNotify}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 2.25C6.62402 2.25 2.25 6.62402 2.25 12C2.25 17.376 6.62402 21.75 12 21.75C17.376 21.75 21.75 17.376 21.75 12C21.75 6.62402 17.376 2.25 12 2.25ZM12 3.75C16.5645 3.75 20.25 7.43555 20.25 12C20.25 16.5645 16.5645 20.25 12 20.25C7.43555 20.25 3.75 16.5645 3.75 12C3.75 7.43555 7.43555 3.75 12 3.75ZM11.25 7.5V13.5H12.75V7.5H11.25ZM11.25 15V16.5H12.75V15H11.25Z"
                  fill="#A0A0A0"
                />
              </svg>
              <span style={{ marginRight: ".5rem" }}>درصورت عدم پرداخت در مهلت مقرر شده، ودیعه شما ضبط خواهد شد.</span>
            </div>
            <Divider style={{ backgroundColor: "#A0A0A0" }} />
            <Holder_Button className="holder-button" style={{ direction: "ltr" }}>
              <Button onClick={handleSubmit} className="btn-green">
                پرداخت
              </Button>
              <Button onClick={(e) => handleCancel()}>بعدا پرداخت میکنم</Button>
            </Holder_Button>
          </div>
        </div>
      </MyModal>
      <Loading isOpen={isLoading} />
    </>
  );
};

export default WinnerModal;
